import React from 'react';
import { socialLinks, personalInfo } from '../data/portfolioData';
import { FaArrowUp } from 'react-icons/fa';
import Icon from './Icon';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p className="footer-text">
          Fatto con <span className="heart">♥</span> e{' '}
          <span className="tech">React + TypeScript</span>
          <br />
          © {new Date().getFullYear()} {personalInfo.name}. Tutti i diritti riservati.
        </p>

        <div className="footer-social">
          {socialLinks.map(link => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              title={link.name}
            >
              <Icon icon={link.icon} />
            </a>
          ))}
        </div>

        <button className="footer-back-top" onClick={scrollToTop}>
          <Icon icon={FaArrowUp} /> Torna su
        </button>
      </div>
    </footer>
  );
};

export default Footer;




